/*
 * KB Puntensysteem — frontend (realisatie Figma-ontwerp)
 * Twee features, beide via de Shopify App Proxy (/apps/kb-punten):
 *   1) Korting-popup: klant met genoeg punten krijgt "je hebt genoeg punten voor 10%/20%
 *      korting op je hele bestelling". Eén klik → /redeem (BON redeemPoint) → kortingscode
 *      wordt stil toegepast via /discount/CODE. States: offer → processing → done.
 *   2) Donatiesectie: klant doneert punten aan Mi Barrio Mi Sueño → /donate (BON adjustPoint).
 *      States van de popup: processing → thanks.
 *
 * Identiteit loopt via de App Proxy: Shopify tekent elke request met de geverifieerde
 * logged_in_customer_id. De browser stuurt NOOIT zelf een klant-id of e-mail mee.
 */
(function () {
  "use strict";

  var PROXY = "/apps/kb-punten";
  // Preview-modus (?kb_preview=1): toont popup + donatie met voorbeelddata, zonder backend.
  var PREVIEW = /[?&]kb_preview=1/.test(location.search);
  var PREVIEW_BALANCE = 2480;

  function el(s, r) { return (r || document).querySelector(s); }
  function all(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function fmt(n) { return new Intl.NumberFormat("nl-NL").format(n); }

  function getJSON(url) {
    // cache: "no-store" + cache-buster: saldo moet altijd vers zijn (bfcache/CDN omzeilen).
    var bust = (url.indexOf("?") === -1 ? "?" : "&") + "_=" + Date.now();
    return fetch(url + bust, { headers: { Accept: "application/json" }, credentials: "same-origin", cache: "no-store" })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, status: r.status, body: b }; }); });
  }
  function postJSON(url, data) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify(data)
    }).then(function (r) { return r.json().then(function (b) { return { ok: r.ok, status: r.status, body: b }; }); });
  }
  function idemKey() {
    try { return (crypto.randomUUID && crypto.randomUUID()) || String(Date.now()) + Math.random(); }
    catch (e) { return String(Date.now()) + Math.random(); }
  }

  function openOverlay(node) { node.hidden = false; requestAnimationFrame(function () { node.classList.add("is-open"); }); }
  function closeOverlay(node, after) {
    node.classList.remove("is-open");
    setTimeout(function () { node.hidden = true; if (after) after(); }, 250);
  }
  // Toon één [data-kb-state] binnen een container, verberg de rest.
  function showState(container, name) {
    all("[data-kb-state]", container).forEach(function (s) { s.hidden = s.getAttribute("data-kb-state") !== name; });
  }
  function setText(root, sel, val) { all(sel, root).forEach(function (n) { n.textContent = val; }); }

  // ============================================================
  // 1) KORTING-POPUP
  // ============================================================
  function initDiscountPopup() {
    var root = el("[data-kb-korting-popup]");
    if (!root) return;

    var cost10 = parseInt(root.getAttribute("data-cost-10"), 10) || 0;
    var cost20 = parseInt(root.getAttribute("data-cost-20"), 10) || 0;
    // 0 (of leeg) = altijd tonen. Alleen bij >0 geldt de frequency-cap.
    var capDays = parseInt(root.getAttribute("data-cap-days"), 10);
    if (!isFinite(capDays) || capDays < 0) capDays = 0;
    var cartCount = parseInt(root.getAttribute("data-cart-count"), 10) || 0;
    var capKey = "kb_korting_popup_dismissed_at";

    if (!PREVIEW && capDays > 0) {
      var last = parseInt(localStorage.getItem(capKey) || "0", 10);
      if (last && Date.now() - last < capDays * 864e5) return;
    }

    var balance = PREVIEW
      ? Promise.resolve({ ok: true, body: { points: PREVIEW_BALANCE } })
      : getJSON(PROXY + "/balance");

    balance.then(function (res) {
      if (!res.ok || !res.body || typeof res.body.points !== "number") return;
      var pts = res.body.points;
      if (!cost10 || pts < cost10) return; // niet genoeg voor de laagste tier → geen popup

      var best = pts >= cost20 && cost20 > 0 ? { tier: "20", cost: cost20 } : { tier: "10", cost: cost10 };

      setText(root, "[data-kb-points]", fmt(pts));
      setText(root, "[data-kb-best-pct]", best.tier + "%");
      setText(root, "[data-kb-best-cost]", fmt(best.cost));
      var redeemBtn = el("[data-kb-redeem]", root);
      if (redeemBtn) redeemBtn.setAttribute("data-kb-redeem", best.tier);

      wireRedeem(root, best, capKey, capDays);
      openOverlay(root);
      document.body.style.overflow = "hidden";
    }).catch(function () {});
  }

  function wireRedeem(root, best, capKey, capDays) {
    var busy = false;
    var errNode = el("[data-kb-error]", root);
    function setErr(msg) { if (errNode) { errNode.textContent = msg || ""; errNode.hidden = !msg; } }
    function dismiss() { document.body.style.overflow = ""; if (capDays > 0) localStorage.setItem(capKey, String(Date.now())); }

    all("[data-kb-close]", root).forEach(function (b) {
      b.addEventListener("click", function () { closeOverlay(root, dismiss); });
    });
    root.addEventListener("click", function (e) { if (e.target === root) closeOverlay(root, dismiss); });

    var checkout = el("[data-kb-checkout]", root);
    if (checkout) checkout.addEventListener("click", function () { window.location.href = "/checkout"; });

    var btn = el("[data-kb-redeem]", root);
    if (!btn) return;
    btn.addEventListener("click", function () {
      if (busy) return;
      busy = true;
      setErr("");
      showState(root, "processing");

      if (PREVIEW) {
        setTimeout(function () {
          setText(root, "[data-kb-done-pct]", best.tier + "%");
          setText(root, "[data-kb-remaining]", fmt(PREVIEW_BALANCE - best.cost));
          showState(root, "done");
          busy = false;
        }, 900);
        return;
      }

      postJSON(PROXY + "/redeem", { tier: best.tier, idempotencyKey: idemKey() })
        .then(function (res) {
          if (res.ok && res.body && res.body.ok && res.body.code) {
            // Kortingscode stil toepassen; Shopify onthoudt hem tot de checkout.
            return fetch("/discount/" + encodeURIComponent(res.body.code), { credentials: "same-origin" })
              .then(function () {
                setText(root, "[data-kb-done-pct]", best.tier + "%");
                if (typeof res.body.remaining === "number") setText(root, "[data-kb-remaining]", fmt(res.body.remaining));
                showState(root, "done");
                if (capDays > 0) localStorage.setItem(capKey, String(Date.now()));
              });
          }
          var code = res.body && res.body.error;
          showState(root, "offer");
          if (code === "insufficient_points") setErr("Je hebt net niet genoeg punten voor deze korting.");
          else if (code === "not_logged_in") setErr("Log eerst in om je punten te gebruiken.");
          else setErr("Er ging iets mis. Probeer het later opnieuw.");
        })
        .catch(function () { showState(root, "offer"); setErr("Er ging iets mis. Probeer het later opnieuw."); })
        .finally(function () { busy = false; });
    });
  }

  // ============================================================
  // 2) DONATIESECTIE
  // ============================================================
  function initDonation() {
    var root = el("[data-kb-donatie]");
    if (!root) return;

    var balanceNode = el("[data-kb-balance]", root);
    var statusNode = el("[data-kb-status]", root);
    var buttons = all("[data-kb-donate]", root);
    var thanks = el("[data-kb-thanks]", root);
    var busy = false;

    var previewBal = PREVIEW_BALANCE;
    function applyBalance(pts) {
      if (balanceNode) balanceNode.textContent = fmt(pts);
      buttons.forEach(function (b) { b.disabled = pts < (parseInt(b.getAttribute("data-cost"), 10) || 0); });
    }
    function refreshBalance() {
      if (PREVIEW) { applyBalance(previewBal); return Promise.resolve(); }
      return getJSON(PROXY + "/balance").then(function (res) {
        if (res.ok && res.body && typeof res.body.points === "number") applyBalance(res.body.points);
      }).catch(function () {});
    }
    function setStatus(msg, kind) {
      if (!statusNode) return;
      statusNode.textContent = msg || "";
      statusNode.className = "kb-donatie__status" + (kind ? " kb-donatie__status--" + kind : "");
      statusNode.hidden = !msg;
    }

    if (thanks) {
      all("[data-kb-close]", thanks).forEach(function (b) {
        b.addEventListener("click", function () { closeOverlay(thanks, function () { refreshBalance(); }); });
      });
      thanks.addEventListener("click", function (e) { if (e.target === thanks) closeOverlay(thanks, function () { refreshBalance(); }); });
    }

    buttons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (busy || btn.disabled) return;
        var tier = btn.getAttribute("data-kb-donate");
        var cost = parseInt(btn.getAttribute("data-cost"), 10) || 0;

        busy = true;
        buttons.forEach(function (b) { b.disabled = true; });
        setStatus("");
        if (thanks) { showState(thanks, "processing"); openOverlay(thanks); }

        if (PREVIEW) {
          setTimeout(function () {
            previewBal -= cost;
            if (thanks) {
              setText(thanks, "[data-kb-thanks-tier]", "€" + tier);
              setText(thanks, "[data-kb-thanks-remaining]", fmt(previewBal));
              showState(thanks, "thanks");
            }
            busy = false; applyBalance(previewBal);
          }, 900);
          return;
        }

        postJSON(PROXY + "/donate", { tier: tier, idempotencyKey: idemKey() })
          .then(function (res) {
            if (res.ok && res.body && res.body.ok) {
              if (thanks) {
                setText(thanks, "[data-kb-thanks-tier]", "€" + tier);
                if (typeof res.body.remaining === "number") setText(thanks, "[data-kb-thanks-remaining]", fmt(res.body.remaining));
                showState(thanks, "thanks");
              }
            } else {
              if (thanks) closeOverlay(thanks);
              var code = res.body && res.body.error;
              if (code === "insufficient_points") setStatus("Je hebt niet genoeg punten voor deze donatie.", "error");
              else if (code === "not_logged_in") setStatus("Log eerst in om je punten te doneren.", "error");
              else if (code === "rate_limited") setStatus("Je hebt net gedoneerd. Probeer het over een uur opnieuw.", "error");
              else if (code === "in_progress") setStatus("Je donatie wordt al verwerkt, moment geduld.", "error");
              else if (code === "no_loyalty_account") setStatus("We konden je puntensaldo niet vinden.", "error");
              else setStatus("Er ging iets mis. Probeer het later opnieuw.", "error");
            }
          })
          .catch(function () { if (thanks) closeOverlay(thanks); setStatus("Er ging iets mis. Probeer het later opnieuw.", "error"); })
          .finally(function () { busy = false; refreshBalance(); });
      });
    });

    refreshBalance();
  }

  function boot() { initDiscountPopup(); initDonation(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
